<template>
  <q-card
    class="q-pa-16"
    flat
  >
    <q-card-section horizontal>
      <q-avatar
        class="check q-mr-12 border-radius-12"
        icon="img:common/icons/best_check.svg"
      />
      <div class="fs-14">
        <b class="fs-18">{{ $t(`refund.${titleKey}`) }}</b>
        <div class="q-my-4 text-grey-8">{{ $t('refund.description') }}</div>
        <span
          class="cursor-pointer text-grey-8 text-underline"
          @click="$refs.modalRef.show()"
        >
          {{ $t('button.read_more') }}
        </span>
      </div>
    </q-card-section>
    <Modal
      ref="modalRef"
      :title="$t(`refund.${titleKey}`)"
      @show.once="onModalShow"
    >
      <div class="default-modal-padding q-pb-24">
        <div class="fs-16">{{ $t('refund.description') }}</div>
        <p class="fs-14">{{ $t('refund.notice') }}</p>
        <q-banner
          class="q-py-16"
          rounded
        >
          <div class="fs-16 q-my-none">
            {{ $t(`refund.list_${titleKey}`) }}
          </div>
          <ul class="q-pl-16 q-mb-none">
            <li
              v-for="text in $tm('refund.list')"
              :key="text"
            >
              {{ text }}
            </li>
          </ul>
        </q-banner>
      </div>
    </Modal>
  </q-card>
</template>

<script setup>
import { computed, inject } from 'vue';

import Modal from '~components/Modal';

const { withoutPartnership } = inject('domain');

const titleKey = computed(() => (withoutPartnership ? 'title' : 'title_with_brand'));

function onModalShow() {
  window.$logEvent?.firebase('passenger_open_price_match');
}
</script>

<style lang="scss" scoped>
.check {
  background: #dff6e8;
}

.q-banner,
.q-card {
  background: #f4fcf7;
  border: 1px solid #caf1d8;
}
</style>
